import React from 'react'
import { TableSeeker } from '@ui-seeker/core'
import AppTitleWithPopup from '@components/@base/TitleWithPopup'
import { Box } from '@mui/material'
import { isEmpty } from '@ui-seeker/utils'


export default function AppDataTable({ title, toolbarProps = {}, ...props }) {

	return <TableSeeker
		title={title}
		titleProps={{ variant: "h6", mt: 1 }}
		{...props}
		options={{
			rowsPerPage: 50,
			rowsPerPageOptions: [5, 20, 50, 100, {label: 'All', value: props.data.length}],
			enhancedSetRowProps: (rowData, dataIndex, idx) => ({
				sx: {
					backgroundColor: idx % 2 === 0 ? "background.grey" : "background.lightGrey",
					borderColor: "colors.grey",
				}
			}),
			search: false,
			print: false,
			viewColumns: false,
			...props?.options,
			customToolbar: () => <Box sx={{ display: "flex", gap: .5 }}>
				{props?.options?.customToolbar && props?.options?.customToolbar()}
				{!isEmpty(toolbarProps) && <AppTitleWithPopup {...toolbarProps} />}
			</Box>,
		}}
	/>
}
